export default function AlertArrowRight() {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.7689 8L5.15803 15.1352C4.95657 15.3241 4.94637 15.6405 5.13523 15.842C5.3241 16.0434 5.64052 16.0536 5.84197 15.8648L13.842 8.36477C14.0527 8.16723 14.0527 7.83277 13.842 7.63523L5.84197 0.135233C5.64052 -0.0536321 5.3241 -0.0434251 5.13523 0.158031C4.94637 0.359487 4.95657 0.675905 5.15803 0.86477L12.7689 8Z'
        fill='#33820D'
      />
    </svg>
  );
}
